import { useState, useEffect } from "react";

// Generate array of all installation images
const INSTALATII_IMAGES = [
  ...Array.from({ length: 60 }, (_, i) => `/instalatii/IMG-20251020-WA${String(i + 1).padStart(4, '0')}.jpg`),
  ...Array.from({ length: 61 }, (_, i) => `/instalatii/IMG-20251023-WA${String(i + 66).padStart(4, '0')}.jpg`)
];

export default function Instalatii() {
  const [lightbox, setLightbox] = useState({ open: false, index: 0 });

  useEffect(() => {
    if (!lightbox.open) return;
    const onKey = (e) => {
      if (e.key === "Escape") setLightbox({ open: false, index: 0 });
      if (e.key === "ArrowLeft")
        setLightbox((s) => ({ ...s, index: (s.index - 1 + INSTALATII_IMAGES.length) % INSTALATII_IMAGES.length }));
      if (e.key === "ArrowRight")
        setLightbox((s) => ({ ...s, index: (s.index + 1) % INSTALATII_IMAGES.length }));
    };
    document.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [lightbox.open]);

  return (
    <main className="bg-gradient-to-b from-sky-50 via-white to-white text-slate-900">
      <section className="mx-auto max-w-6xl px-4 py-10 md:py-14">
        <div className="mb-8">
          <h1 className="text-3xl font-extrabold tracking-tight md:text-4xl">
            Portofoliu Lucrări Realizate
          </h1>
          <p className="mt-3 text-lg text-slate-700">
            Peste 120 de proiecte finalizate în Arad: instalații sanitare, centrale termice, pompe de căldură, 
            încălzire în pardoseală și instalații solare. Click pe imagine pentru detalii.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3">
          {INSTALATII_IMAGES.map((src, i) => (
            <button
              key={src}
              type="button"
              onClick={() => setLightbox({ open: true, index: i })}
              className="group block overflow-hidden rounded-lg border border-slate-200/70 bg-white shadow-sm hover:shadow-md transition-shadow"
              aria-label={`Mărește instalația ${i + 1}`}
            >
              <img
                src={src}
                alt={`Instalație ${i + 1}`}
                loading="lazy"
                className="aspect-[4/3] w-full object-cover transition-transform duration-200 group-hover:scale-105"
              />
            </button>
          ))}
        </div>
      </section>

      <Lightbox
        open={lightbox.open}
        src={INSTALATII_IMAGES[lightbox.index]}
        onClose={() => setLightbox({ open: false, index: 0 })}
        onPrev={() => setLightbox((s) => ({ open: true, index: (s.index - 1 + INSTALATII_IMAGES.length) % INSTALATII_IMAGES.length }))}
        onNext={() => setLightbox((s) => ({ open: true, index: (s.index + 1) % INSTALATII_IMAGES.length }))}
      />
    </main>
  );
}

function Lightbox({ open, src, onClose, onPrev, onNext }) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[80] bg-black/80" aria-modal="true" role="dialog" onClick={onClose}>
      <button
        aria-label="Închide"
        className="absolute right-4 top-4 rounded-lg bg-white/10 p-2 text-white backdrop-blur transition hover:bg-white/20"
        onClick={(e) => {
          e.stopPropagation();
          onClose();
        }}
      >
        <svg width="22" height="22" viewBox="0 0 24 24" aria-hidden="true">
          <path d="M6 6l12 12M6 18L18 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        </svg>
      </button>

      <div className="flex h-full items-center justify-center px-3" onClick={(e) => e.stopPropagation()}>
        <button
          className="mr-2 hidden rounded-lg bg-white/10 p-3 text-white backdrop-blur transition hover:bg-white/20 md:block"
          aria-label="Anterior"
          onClick={onPrev}
        >
          <svg width="22" height="22" viewBox="0 0 24 24">
            <path d="M15 6l-6 6 6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" fill="none" />
          </svg>
        </button>

        <img src={src} alt="Imagine mărită" className="max-h-[80vh] w-auto max-w-[90vw] rounded-2xl object-contain shadow-2xl" />

        <button
          className="ml-2 hidden rounded-lg bg-white/10 p-3 text-white backdrop-blur transition hover:bg-white/20 md:block"
          aria-label="Următor"
          onClick={onNext}
        >
          <svg width="22" height="22" viewBox="0 0 24 24">
            <path d="M9 6l6 6-6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" fill="none" />
          </svg>
        </button>
      </div>

      <div className="absolute inset-x-0 bottom-0 flex items-center justify-between p-4 md:hidden">
        <button className="rounded-lg bg-white/10 px-4 py-2 text-white backdrop-blur transition hover:bg-white/20" onClick={(e) => { e.stopPropagation(); onPrev(); }}>
          Anterior
        </button>
        <button className="rounded-lg bg-white/10 px-4 py-2 text-white backdrop-blur transition hover:bg-white/20" onClick={(e) => { e.stopPropagation(); onNext(); }}>
          Următor
        </button>
      </div>
    </div>
  );
}
